const maps: string[] = [
    "/static/img/map-polygon.svg",
];

const containers = document.querySelectorAll<HTMLElement>(".jpmap");

const offsets: { [key: string]: { x: number; y: number } } = {
    "北海道": {
        x: 0,
        y: -20,
    },
    "東京": {
        x: 0,
        y: -5,
    },
    "新潟": {
        x: 0,
        y: 10,
    },
    "福井": {
        x: 0,
        y: 18,
    },
}

const defaultColor = "#86c912";
const hoverColor = "#6fba7b";

maps.forEach(async (map, idx) => {
    const res = await fetch(map);
    if (!res.ok) return;

    const svgText = await res.text();
    const container = containers[idx];
    if (!container) return;

    container.innerHTML = svgText;

    const svgRoot = container.querySelector<SVGSVGElement>("svg");
    if (!svgRoot) return;

    const prefs = svgRoot.querySelectorAll<SVGGraphicsElement>(".prefecture");

    prefs.forEach((pref) => {
        // ---------- ラベル生成 ----------
        const titleNode = pref.querySelector("title");
        if (!titleNode) return;

        const titleInfo = (titleNode.textContent ?? "").split("/");
        const labelText = titleInfo[0].trim();
        const link = titleInfo[1].trim().toLowerCase();
        const { x, y, width, height } = pref.getBBox();     // バウンディングボックス

        const label = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "text"
        );
        label.textContent = labelText;

        // 中央座標
        label.setAttribute("x", `${(x + width / 2) + (offsets[labelText]?.x ?? 0)}`);
        label.setAttribute("y", `${(y + height / 2) + (offsets[labelText]?.y ?? 0)}`);

        // 中央揃え
        label.setAttribute("text-anchor", "middle");        // 横方向中央
        label.setAttribute("dominant-baseline", "middle");  // 縦方向中央
        label.setAttribute("font-size", "16");
        label.setAttribute("pointer-events", "none");

        svgRoot.appendChild(label);

        // ---------- ホバー効果 ----------
        pref.addEventListener("mouseover", (e) => {
            (e.currentTarget as SVGGraphicsElement).style.fill = hoverColor;
        });
        pref.addEventListener("mouseleave", (e) => {
            (e.currentTarget as SVGGraphicsElement).style.fill = defaultColor;
        });
        // クリックイベントの追加
        pref.addEventListener("click", () => {
            // 都道府県名に対応するURLへ遷移
            window.location.href = `/voice-training/${link}`;
        });
        pref.style.fill = defaultColor;
    });
});